<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M14.719999940395356,7.87C13.179999940395355,7.2,11.729999940395356,5.19,11.019999940395355,3.92C10.109999940395355,1.95,9.929999940395355,0,6.139999940395355,0C4.049999940395355,0,2.709999940395355,0.61,1.9199999403953552,2.12C1.2699999403953552,3.36,0.9999999403953552,5.21,0.9999999403953552,7.83C0.9999999403953552,7.83,0.9999999403953552,8.62,0.9999999403953552,8.62C0.9999999403953552,9.27,1.5999999403953553,9.8,2.3499999403953553,9.8C2.689999940395355,9.8,2.9899999403953554,9.69,3.229999940395355,9.51C3.399999940395355,9.99,3.9099999403953554,10.35,4.519999940395355,10.35C4.929999940395355,10.35,5.299999940395355,10.19,5.549999940395355,9.93C5.7799999403953555,10.3,6.219999940395355,10.56,6.739999940395355,10.56C7.309999940395355,10.56,7.789999940395355,10.25,7.989999940395355,9.82C7.989999940395355,9.82,7.999999940395355,10.45,7.999999940395355,10.45C7.999999940395355,10.45,7.999999940395355,14.5,7.999999940395355,14.5C7.999999940395355,15.33,8.669999940395355,16,9.499999940395355,16C10.329999940395355,16,10.999999940395355,15.33,10.999999940395355,14.5C10.999999940395355,14.5,10.999999940395355,7.9,10.999999940395355,7.9C11.579999940395355,8.31,12.549999940395356,9.11,13.469999940395356,9.19C15.039999940395354,9.33,15.289999940395354,8.12,14.719999940395356,7.87C14.719999940395356,7.87,14.719999940395356,7.87,14.719999940395356,7.87Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'HandDown',
} as DefineComponent
</script>
